var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { CaseInfoService } from '~/services/domain-service/case-info.service';
var CollectionHistory = /** @class */ (function (_super) {
    __extends(CollectionHistory, _super);
    function CollectionHistory() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.collectionHistory = [];
        _this.caseInfo = {};
        _this.dialog = {
            telDetail: false,
            visitDetail: false,
            assistDetail: false,
            legalFilingStepDetail: false,
            legalHoldCourtDetail: false,
            legalImplementDetail: false,
            legalCloseCasetDetail: false,
            outerTelDetail: false,
            outerVisitDetail: false
        };
        _this.clickData = {};
        _this.srcList = [];
        return _this;
    }
    CollectionHistory.prototype.created = function () {
        var url = location.search;
        url = url.substring(1);
        var urlList = url.split('&');
        var account = urlList[0].split('=')[1];
        this.queryCollection(account);
    };
    CollectionHistory.prototype.queryCollection = function (caseNumber) {
        var _this = this;
        this.caseInfoService.queryCaseCollectionRecords(caseNumber).subscribe(function (data) {
            if (data) {
                _this.caseInfo = data;
                var detailList = data.caseCollectionRecordDetailResponseList;
                for (var _i = 0, detailList_1 = detailList; _i < detailList_1.length; _i++) {
                    var detail = detailList_1[_i];
                    var action = detail.followupAction;
                    switch (action) {
                        case "电催":
                            detail.color = "#DC143C";
                            break;
                        case "外访":
                            detail.color = "#FF7F50";
                            break;
                        case "开庭":
                        case "立案":
                        case "执行":
                        case "结案":
                            detail.color = "#6495ED";
                            break;
                        case "委外外访":
                            detail.color = "#ffA500";
                            break;
                        case "委外电催":
                            detail.color = "#ff4500";
                            break;
                    }
                }
                _this.collectionHistory = data.caseCollectionRecordDetailResponseList;
            }
        });
    };
    CollectionHistory.prototype.clickFollowupDetail = function (item) {
        var action = item.followupAction;
        switch (action) {
            case "电催":
            case "委外电催":
                this.showTelDetail(item);
                break;
            case "外访":
            case "委外外访":
                this.showVisitDetail(item);
                break;
            case "开庭":
                this.showHoldCourt(item);
                break;
            case "立案":
                this.showLegalFilingStepDetail(item);
                break;
            case "执行":
                this.showImplementCourt(item);
                break;
            case "结案":
                this.showCloseCaseCourt(item);
                break;
        }
    };
    CollectionHistory.prototype.showCloseCaseCourt = function (item) {
        this.clickData = item.caseLegalRecordQueryResponse;
        this.dialog.legalCloseCasetDetail = true;
    };
    CollectionHistory.prototype.showImplementCourt = function (item) {
        this.clickData = item.caseLegalRecordQueryResponse;
        this.dialog.legalImplementDetail = true;
    };
    CollectionHistory.prototype.showHoldCourt = function (item) {
        this.clickData = item.caseLegalRecordQueryResponse;
        this.dialog.legalHoldCourtDetail = true;
    };
    CollectionHistory.prototype.showLegalFilingStepDetail = function (item) {
        this.clickData = item.caseLegalRecordQueryResponse;
        this.dialog.legalFilingStepDetail = true;
    };
    CollectionHistory.prototype.showVisitDetail = function (item) {
        this.clickData = item.caseFollowupRecordQueryResponse;
        this.srcList = this.clickData.enclosureUrls ? this.clickData.enclosureUrls.split(",") : [];
        this.dialog.visitDetail = true;
    };
    CollectionHistory.prototype.showTelDetail = function (item) {
        this.clickData = item.caseFollowupRecordQueryResponse;
        if (this.clickData.files) {
            var fileList = JSON.parse(this.clickData.files);
            this.srcList = fileList.map(function (item) {
                return item.url;
            });
        }
        else {
            this.srcList = [];
        }
        this.dialog.telDetail = true;
    };
    __decorate([
        Dependencies(CaseInfoService)
    ], CollectionHistory.prototype, "caseInfoService", void 0);
    CollectionHistory = __decorate([
        Component({
            components: {},
        })
    ], CollectionHistory);
    return CollectionHistory;
}(Vue));
export default CollectionHistory;
